<template>
<div class="chapter">
<div class="inner_page">
<p class="copy"><b>PUBLISHER:</b> Amy Marson</p>
<p class="copy"><b>CREATIVE DIRECTOR:</b> Gailen Runge</p>
<p class="copy"><b>ACQUISITIONS EDITOR:</b> Roxane Cerda</p>
<p class="copy"><b>MANAGING EDITOR:</b> Liz Aneloski</p>
<p class="copy"><b>EDITORS:</b> Liz Aneloski and Katie Van Amburg</p>
<p class="copy"><b>TECHNICAL EDITOR:</b> Helen Frost</p>
<p class="copy"><b>COVER/BOOK DESIGNER:</b> April Mostek</p>
<p class="copy"><b>PRODUCTION COORDINATOR:</b> Tim Manibusan</p>
<p class="copy"><b>PRODUCTION EDITOR:</b> Alice Mace Nakanishi</p>
<p class="copy"><b>ILLUSTRATOR:</b> Mary E. Flynn</p>
<p class="copy"><b>PHOTO ASSISTANT:</b> Mai Yong Vang</p>
<p class="copy"><b>COVER AND STYLE PHOTOGRAPHY</b> by Lucy Glover and <br/><b>INSTRUCTIONAL PHOTOGRAPHY</b> by Mai Yong Vang of C&amp;T Publishing, Inc., unless otherwise noted</p>
<p class="copy">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
<p class="fig"><img alt="image" src="images/pg2-1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?5de8934e